import { HttpMethod } from '../../constants';
function replaceEnterpriseId(enterpriseId: string): string {
  return this.path.replace(':enterpriseId', enterpriseId);
}
function replaceEnterpriseAndProviderId(enterpriseId: string, providerId: string): string {
  return this.path.replace(':enterpriseId', enterpriseId).replace(':providerId', providerId);
}
function replaceEnterpriseProviderAndBlackoutDateId(enterpriseId: string, providerId: string, blackoutDateId: string): string {
  return this.path.replace(':enterpriseId', enterpriseId).replace(':providerId', providerId).replace(':blackoutDateId', blackoutDateId);
}
export const providerEndpoints = {
  [HttpMethod.Get]: {
    EnterpriseProviders: {
      path: '/enterprises/:enterpriseId/providers',
      route: replaceEnterpriseId
    },
    EnterpriseProvider: {
      path: '/enterprises/:enterpriseId/providers/:providerId',
      route: replaceEnterpriseAndProviderId
    },
    ProviderBlackoutDates: {
      path: '/enterprises/:enterpriseId/providers/:providerId/blackout-dates',
      route: replaceEnterpriseAndProviderId
    }
  },
  [HttpMethod.Patch]: {
    EnterpriseProvider: {
      path: '/enterprises/:enterpriseId/providers/:providerId',
      route: replaceEnterpriseAndProviderId
    }
  },
  [HttpMethod.Post]: {
    ProviderBlackoutDate: {
      path: '/enterprises/:enterpriseId/providers/:providerId/blackout-dates',
      route: replaceEnterpriseAndProviderId
    }
  },
  [HttpMethod.Delete]: {
    ProviderBlackoutDate: {
      path: '/enterprises/:enterpriseId/providers/:providerId/blackout-dates/:blackoutDateId',
      route: replaceEnterpriseProviderAndBlackoutDateId
    }
  }
};
export default providerEndpoints;